<template>
  <div class="users">
    <h2 class="no-margin mb-10">{{ $t('users') }}</h2>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/' }">{{ $t('dashboard') }}</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $t('users') }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="line"></div>
    <users-list v-if="self !== null"/>
  </div>
</template>

<script>
import UsersList from '@/components/users/List'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'self'
    ])
  },
  components: {
    UsersList
  }
}
</script>
